'use strict';
import { TyProbColor } from '@/components/typhoon_tw/settings'

export class TaiwanCountyBound {
    constructor(src_path) {
        this.init_time_z = null
        this.tau = 0
        this.data = null
        this.visible = false

        this.county_bound = new L.GeoJsonLayer({
            style: {
                color: 'rgb(220,220,220)',
                weight: 1,
                opacity: 1,
                fillOpacity: 0
            },
            src: src_path
        });

    }

    set_init_time_z(init_time_z) {
        this.init_time_z = Date.dtgptime(init_time_z).setTimezone(0).toLocal()
        this.tau = 0
    }

    set_tau(dtg) {
        let datetime = Date.dtgptime(dtg).setTimezone(0).toLocal()
        this.tau = datetime.diffHours(this.init_time_z)
    }

    set_data(data) {
        this.data = data
        this.set_probability_visible()
    }

    set_visible(visible) {
        this.visible = visible
        this.set_probability_visible()
    }

    set_probability_visible() {
        let self = this
        if (!this.data) {
            return
        }

        if (this.visible) {
            let matched_tau_info = []
            for (let data of this.data) {
                let prob = data.probability.find(prob => self.tau === prob.tau)
                if (prob) {
                    matched_tau_info.push(prob)
                }
            }

            this.county_bound._layer.eachLayer((layer) => {
                let county_prob = 0
                for (let info of matched_tau_info) {
                    let prob_counties = info.probability
                    let layer_county = layer.feature.properties.name
                    if (prob_counties.hasOwnProperty(layer_county) && county_prob < prob_counties[layer_county]) {
                        county_prob = prob_counties[layer_county]
                    }
                }

                let color_prob = Object.keys(TyProbColor).find(prob => prob >= county_prob)
                layer.setStyle({
                    fillColor: TyProbColor[color_prob],
                    fill: true,
                    fillOpacity: 0.6
                })
            })
        }
        else {
            this.county_bound._layer.eachLayer((layer) => {
                layer.setStyle({
                    fillOpacity: 0
                })
            })
        }
    }

    show(map) {
        map.addLayer(this.county_bound)
    }

    hide(map) {
        map.removeLayer(this.county_bound)
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/ty_county_bound.js